export default __webpack_public_path__ + "5570a44a5f2168d42ad5bc07fb4e16fa.svg";